export default "__VITE_ASSET__DJYVA6cC__"